import JumpHistoryComponent from './index.js'

if (!window.AliPlayerComponent) {
  window.AliPlayerComponent = {}
}
window.AliPlayerComponent.JumpHistoryComponent = JumpHistoryComponent



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/components/JumpHistoryComponent/export.js